import { render, staticRenderFns } from "./OfferAssociations.vue?vue&type=template&id=a5aec3c0"
import script from "./OfferAssociations.vue?vue&type=script&lang=js"
export * from "./OfferAssociations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports